/**
 * Clears every device-local store that keeps Leo preview fixes alive after reload.
 */

import { clearLivePapers } from "@/lib/assessment-live-paper"
import { clearAllLibraryBankRowOverlays } from "@/lib/library-bank-row-overlays"
import { clearAllComposerFormDrafts } from "@/lib/question-version-history/composer-draft"
import { clearAssessmentQuestionHistory } from "@/lib/question-version-history/assessment-session"

/** Bank overlays plus live paper rosters (Add questions and assessment detail). */
export function resetLeoPreviewFixesOnDevice() {
  clearAllLibraryBankRowOverlays()
  clearLivePapers()
  clearAssessmentQuestionHistory()
  clearAllComposerFormDrafts()
}
